var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagazineGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_5879",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_5879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59503 18.6765H14.2647V15.0622C14.2647 14.8363 14.3411 14.6468 14.494 14.494C14.6468 14.3411 14.8363 14.2647 15.0622 14.2647H18.6765V6.59503C18.6765 6.51584 18.651 6.45079 18.6001 6.39988C18.5492 6.34897 18.4842 6.32351 18.405 6.32351H6.59503C6.51584 6.32351 6.45079 6.34897 6.39988 6.39988C6.34897 6.45079 6.32351 6.51584 6.32351 6.59503V18.405C6.32351 18.4842 6.34897 18.5492 6.39988 18.6001C6.45079 18.651 6.51584 18.6765 6.59503 18.6765ZM6.59503 20C6.1564 20 5.78091 19.8438 5.46855 19.5314C5.15618 19.2191 5 18.8436 5 18.405V6.59503C5 6.1564 5.15618 5.78091 5.46855 5.46855C5.78091 5.15618 6.1564 5 6.59503 5H18.405C18.8436 5 19.2191 5.15618 19.5314 5.46855C19.8438 5.78091 20 6.1564 20 6.59503V14.1731C20 14.3882 19.9587 14.5933 19.8761 14.7883C19.7935 14.9834 19.6799 15.1533 19.5351 15.2981L15.2981 19.5351C15.1533 19.6799 14.9834 19.7935 14.7883 19.8761C14.5933 19.9587 14.3882 20 14.1731 20H6.59503ZM11.8383 14.0271H9.14028C8.95278 14.0271 8.79561 13.9637 8.66877 13.8368C8.54194 13.7099 8.47853 13.5527 8.47853 13.3651C8.47853 13.1775 8.54194 13.0204 8.66877 12.8937C8.79561 12.767 8.95278 12.7036 9.14028 12.7036H11.8383C12.0257 12.7036 12.1829 12.7671 12.3097 12.894C12.4366 13.0209 12.5 13.1781 12.5 13.3657C12.5 13.5533 12.4366 13.7104 12.3097 13.8371C12.1829 13.9638 12.0257 14.0271 11.8383 14.0271ZM15.8597 10.5147H9.14028C8.95278 10.5147 8.79561 10.4512 8.66877 10.3244C8.54194 10.1975 8.47853 10.0402 8.47853 9.85265C8.47853 9.66506 8.54194 9.50792 8.66877 9.38123C8.79561 9.25454 8.95278 9.19119 9.14028 9.19119H15.8597C16.0472 9.19119 16.2044 9.25463 16.3312 9.38151C16.4581 9.50841 16.5215 9.66565 16.5215 9.85322C16.5215 10.0408 16.4581 10.1979 16.3312 10.3246C16.2044 10.4513 16.0472 10.5147 15.8597 10.5147Z",
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineGrey);
export default __webpack_public_path__ + "static/media/magazine_grey.1491f2a88e2eedbb41660d39a4b7a8cf.svg";
export { ForwardRef as ReactComponent };